import { Spin } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { GetRequestDetailsAction } from "../../redux/order/order.action";
import ClientCalcStatuse from "./ClientCalcStatuse";

class ClientStatues extends Component {

    state = {
        showAdd: false,
        myData:{}
    }

    handelShowInfo = (data) => {
        this.setState({showAdd: false, myData:data===null?{}:data});
        this.props.GetRequestDetailsAction(this.props.RequestDetails.Id);
    }

  render() {
      const {showAdd} = this.state;
      const {loading, StatusLogs} = this.props;
      console.log(StatusLogs, "sadfsdfsd")
    return (
      <Spin spinning={loading}>
        <div className="client-info-wrapper">
          <header className="client-header">
            <h2 className="header-title">حالات الطلب</h2>
          </header>
          <div className="user-statues-wrapper">
            {
              StatusLogs &&
            <ClientCalcStatuse
            StatusLogs={StatusLogs} />
          }
          </div> 
        </div>
      </Spin>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  GetRequestDetailsAction:(data)=>dispatch(GetRequestDetailsAction(data)),
})
const mapStateToProps = (state) => ({
  RequestDetails:state.order.RequestDetails
}) 
export default connect(mapStateToProps,mapDispatchToProps)(ClientStatues);  